module.exports = __webpack_public_path__ + "static/APIDocRoot-f8968094fae3afb3b091c2cf4559538f.png";